(ns ui.view.card.entity-list.view
  (:require
   [ui.components.skeleton.view :as skeleton]))

;; Generic stuff for entity listing cards (fees, tasks etc.)

(defn loading-skeleton
  [{:keys [num-of-rows]
    :or {num-of-rows 3}}]
  [:div
   {:class "flex flex-col gap-2"}
   (->> (range num-of-rows)
        (map (fn [idx]
               ^{:key (str idx)}
               [skeleton/view
                {:class "w-full h-10"}])))])
